var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "volume",
      staticStyle: { position: "relative" },
      on: {
        mouseenter: _vm.volume_mouseenter_handler,
        mouseleave: _vm.volume_mouseleave_handler
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "icon",
          staticStyle: { position: "relative" },
          on: { click: _vm.volume_click_handler }
        },
        [
          _c("i-volume", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.is_off_volume,
                expression: "!is_off_volume"
              }
            ],
            attrs: { color: _vm.is_show_volume ? _vm.hight_color : "white" }
          }),
          _vm._v(" "),
          _c("i-volume-off", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.is_off_volume,
                expression: "is_off_volume"
              }
            ],
            attrs: { color: _vm.is_show_volume ? _vm.hight_color : "white" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            position: "absolute",
            top: "-135px",
            "padding-bottom": "10px",
            left: "50%",
            transform: "translateX(-60%)"
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.is_show_volume,
                  expression: "is_show_volume"
                }
              ],
              staticStyle: {
                padding: "10px 10px 15px",
                background: "rgb(57,57,57)"
              }
            },
            [
              _c("el-slider", {
                attrs: { vertical: "", height: "100px" },
                on: { input: _vm.volume_handler },
                model: {
                  value: _vm.volume,
                  callback: function($$v) {
                    _vm.volume = $$v
                  },
                  expression: "volume"
                }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be5c876c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be5c876c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/player_control/volume.vue
// module id = null
// module chunks = 